// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"ac26fa35","177":"412d829a","976":"f9e9df77"}[chunkId] + ".chunk.css";
};